/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCollapseAll = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M12 8.169 6.831 3 5.54 4.292l5.169 5.17c1.292 1.291 2.584-.001 2.584-.001l5.17-5.169L17.168 3zM12 15.831 17.169 21l1.292-1.292-5.169-5.17c-1.292-1.291-2.584.001-2.584.001l-5.17 5.169L6.832 21z" /></svg>;
export default SvgCollapseAll;